import { SYSTEM_ERROR, Girl_2023_ID } from "config/CONSTANTS";
import axios from "axios";
import { GET_GAME_INFO } from "../CONSTANTS";

/**
 * Function to vote.
 */
export const getGirl2023Info = () => {
  return new Promise((resolve, reject) => {
    try {
      axios
        .post(GET_GAME_INFO(), {
          gameId: Girl_2023_ID,
        })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          console.log("getGameInfo > axios err=", err);
          reject("Error in getGameInfo axios!");
        });
    } catch (error) {
      console.error("in userServices > getGameInfo, Err===", error);
      reject(SYSTEM_ERROR);
    }
  });
};
